import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { MFAEnrollment } from '../components/auth/MFAEnrollment';
import { Button } from '../components/ui/button';
import { Card, CardDescription, CardHeader } from '../components/ui/card';
import { ShieldAlert, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { AuthCardTitle, AuthShell } from '../components/auth/AuthShell';

export const ForceMFA: React.FC = () => {
    const { isMfaEnrolled, logout } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (isMfaEnrolled) {
            navigate('/dashboard');
        }
    }, [isMfaEnrolled, navigate]);

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login');
        } catch (error) {
            console.error('Failed to log out', error);
            toast.error('Failed to sign out. Please try again.');
        }
    };

    return (
        <AuthShell contentClassName="max-w-[34rem]">
            <div className="w-full max-w-md space-y-6">
                <Card className="border-status-warning-foreground/20 bg-card">
                    <CardHeader className="space-y-3 pb-6">
                        <div className="mb-1 flex h-12 w-12 items-center justify-center bg-status-warning text-status-warning-foreground">
                            <ShieldAlert className="h-6 w-6" />
                        </div>
                        <AuthCardTitle className="text-3xl font-normal text-foreground">Security update required</AuthCardTitle>
                        <CardDescription>
                            Set up multi-factor authentication to protect your account and firm data.
                        </CardDescription>
                    </CardHeader>
                </Card>

                <MFAEnrollment />

                <div className="text-center">
                    <Button variant="ghost" onClick={handleLogout} className="text-muted-foreground">
                        <LogOut className="mr-2 h-4 w-4" />
                        Sign out
                    </Button>
                </div>
            </div>
        </AuthShell>
    );
};
